<template>
<div class="ui tiny modal amazonGiftDialog" id="amazon-gift-dialog">
  <div class="image">
    <img class="pcOnly" :src="imageUrl('/amazon_popup_pc.png')">
    <img class="spOnly" :src="imageUrl('/amazon_popup_sp.png')">
  </div>
  <div class="actions">
    <div class="close" @click="closeDialog">閉じる</div>
  </div>
</div>
</template>

<script>
export default {
  mounted: function() {
      const popupShown = localStorage.getItem('amazon_gift_popup_shown');
      if (!popupShown) {
          $('#amazon-gift-dialog').modal('show');
          localStorage.setItem('amazon_gift_popup_shown', 'true');
      }
  },
  methods: {
    closeDialog: function() {
        $('#amazon-gift-dialog').modal('hide');
    },
  }
};
</script>
